import { Button, Grid, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import ImageBackground from "../../Assets/Images/background-contnt.png";
import "../../Assets/Styles/Customer/customer-info.css";
import "../../Assets/Styles/Customer/customer-account-info.css";
import "../../Assets/Styles/Customer/font-size.css";

import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import useWindowDimensions from "../../Components/useWindowDimension";
import * as CustomerService from "../../Services/customer-service";
import LoadingOverlay from "react-loading-overlay-nextgen";
import CustomNav from "../../Components/custom-nav/CustomNav";
import FooterCustomer from "../../Layouts/footer/FooterCustomer";
import { countTimeExpired, validateValue } from "../../Services/service";
import { ToastContainer } from "react-toastify";

export default function CustomerChangePassword() {
  const [objectDto, setObjectDto] = useState(localStorage.getItem("aaa") ? JSON.parse(localStorage.getItem("aaa")) : null );
  countTimeExpired(objectDto, setObjectDto);
  const [activeItem, setActiveItem] = useState({ title: t("customerinfo"), icon: <i className="fa fa-folder" />, content: "", no: 0});
  const { height, width } = useWindowDimensions();
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState([
    { title: t("presentpassword"), value: "", show: false },
    { title: t("newpassword"), value: "", show: false },
    { title: t("renewpassword"), value: "", show: false }
  ]);
  useEffect(() => {
      }, [i18n]);
  useEffect(() => {
    document.title = "Phu Hung Life - Doi Mat Khau";
  }, []);
  useEffect(() => {
    if (!objectDto) {
      CustomerService.LogOut(setObjectDto);
    }
  }, [objectDto]);
  const toggleShowPassword = (index) => {
    setInfo(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, show: !item.show } : item
      )
    );
  };

  const divStyle = {
    backgroundImage: `url(${ImageBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100vw",
    height: height,
    backgroundRepeat: "no-repeat"
  };

  function validateChangePassword() {
    const presentPassword = info[0].value.trim();
    const newPassword = info[1].value.trim();
    const reNewPassword = info[2].value.trim();
    if (!validateValue(presentPassword) || !validateValue(newPassword) || !validateValue(reNewPassword)) {
      alert(t("messagepleasefillallfields")); 
      return false;
    }
    if (newPassword !== reNewPassword) {
      alert(t("messageblankpassretype")); 
      return false;
    }
    if (presentPassword === newPassword) {
      alert(t("messageblankpassmustnotsamewithcurpass"));
      return false;
    }
    return true;
}

  const handleSubmit = () => {
    if(!validateChangePassword()) return;
    setLoading(true);
    CustomerService.changePassword(info[0].value.trim(), info[1].value.trim(), setLoading, setInfo);
  };

  return (
    <>
      <ToastContainer newestOnTop={true} autoClose={15000} />
      <div className="nav-container" style={{ height }}>
        <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectDto} setObjectDto={setObjectDto} width={width} height={height}/>
        <div className="customer-info-container" style={divStyle}>
          <Grid container spacing={1} className="grid-account-info">
            <Grid item xs={12}>
              <span className="title-header-account-info header-title-customer">
                {t("customerchangepassword")}
              </span>
            </Grid>

            {info.map((item, index) => (
              <Grid container justifyContent="center" key={index}>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <TextField className="css-textfield-login" margin="normal" fullWidth size="small" placeholder={item.title}
                    value={item.value} type={item.show ? "text" : "password"}
                    onChange={(e) =>
                        setInfo(prev =>
                        prev.map((it, i) =>
                            i === index ? { ...it, value: e.target.value } : it
                        )
                        )
                    }
                    InputProps={{
                        endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                            size="small"               
                            onClick={() => toggleShowPassword(index)}
                            edge="end"
                            >
                            {item.show ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        ),
                        sx: {
                        height: 36,                      
                        paddingRight: "4px"              
                        }
                    }}
                    inputProps={{
                        style: {
                        padding: "6px 10px"            
                        }
                    }}
                    />
                </Grid>
              </Grid>
            ))}
            <Grid container justifyContent="center" style={{ marginTop: 16 }}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Button variant="contained" className="css-button-login" component="label" fullWidth
                    onClick={handleSubmit}
                    sx={{
                        textAlign: "center", borderRadius: "5px", fontWeight: 500, backgroundColor: "#DFB246", color: "white", mb: 1,
                        ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }
                    }}>
                    <span className="css-button-login">{t("changepassword")}</span>
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {loading && (
            <LoadingOverlay
              className="loading_overlay_content_customer"
              active
              spinner
              text={t("loading")}
            />
          )}
        </div>
      </div>

      <FooterCustomer />
    </>
  );
}
